import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { dataTable } from 'src/app/models/dataTable.model';
import { BookService } from 'src/app/services/book.service';

@Component({
  selector: 'app-movimenti-librerie-dialog',
  templateUrl: './movimenti-librerie-dialog.component.html',
  styleUrls: ['./movimenti-librerie-dialog.component.scss']
})
export class MovimentiLibrerieDialogComponent implements OnInit {

  movimenti: dataTable = {
    header: [
        'Titolo', 'Quantità'
    ],
    rows: [ 
    ]
  };

  constructor( public dialogRef: MatDialogRef<MovimentiLibrerieDialogComponent>,
    private bookservice: BookService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {
      this.dialogContent();
      //console.log(this.data);
    }
  
    onUndoClick(){
      this.dialogRef.close();
    }
  
    dialogContent(){
      this.movimenti.rows = [];
      this.bookservice
      .getBestSellerBook(this.data.start,this.data.stop,this.data.type,this.data.limit,this.data.libreria)
      .subscribe((data:any)=>{
        data.forEach(element => {
          this.movimenti.rows.push(
            [
                element.titolo,
                Number(element.quantita), 
            ] 
          )
      });
      });
    }
  

}
